// VibeVox: ЛЕНИВАЯ загрузка локалей дашборда.
//
// Раньше dashboard/i18n/index.js статически импортировал ВСЕ локали (110 шт. после
// добавления 108 языков) → ~43MB raw / ~9.5MB gzip в стартовом бандле у КАЖДОГО
// оператора при КАЖДОЙ загрузке. Здесь в бандл попадает только English; остальные
// локали Vite раскладывает по отдельным чанкам (import.meta.glob = динамический
// import) и грузит ТОЛЬКО активный язык по требованию (~0.4MB вместо 9.5MB).
//
// fallbackLocale='en' страхует промахи: если локаль не догрузилась/нет файла —
// показываем English, а не сырые ключи интерфейса.
import { createI18n } from 'vue-i18n';
import en from './locale/en';

// Карта: './locale/<code>/index.js' -> () => import(...). Lazy (Vite по умолчанию).
const localeLoaders = import.meta.glob('./locale/*/index.js');

export const i18n = createI18n({
  legacy: false, // https://github.com/intlify/vue-i18n/issues/1902
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
});

/**
 * Догружает сообщения локали (если ещё не загружены) и переключает интерфейс на неё.
 * Безопасно для несуществующих/непереведённых локалей — упадёт на English.
 * Вызывать ВЕЗДЕ, где меняется язык интерфейса (вместо прямого i18n.locale = ...).
 * @param {string} locale ISO-код локали (как папка в i18n/locale/<code>)
 * @returns {Promise<void>}
 */
export async function loadLocale(locale) {
  const target = locale || 'en';
  if (target !== 'en' && !i18n.global.availableLocales.includes(target)) {
    const loader = localeLoaders[`./locale/${target}/index.js`];
    if (loader) {
      try {
        const mod = await loader();
        i18n.global.setLocaleMessage(target, mod.default || mod);
      } catch (e) {
        // не удалось загрузить — fallbackLocale 'en' покажет английский
      }
    }
  }
  i18n.global.locale.value = target;
}
